<app-modal
  #delete
  [modalMessage]="app.text.import.deleteAllDocs"
  [modalTitle]="app.text.import.deleteTitle"
  (ok)="app.import.deleteDocs(deletingType)"
  >
</app-modal>

<app-import-stepper></app-import-stepper>
<div class="card import-container col-8 offset-md-2">
  @if (app.import.step === 'first') {
    <div class="row">
      <div
        class="col-6 d-flex justify-content-center align-items-center excel-section"
        >
        @if (showExcelFileBtn) {
          <button
            class="btn d-flex justify-content-center align-items-center type-btn"
        [ngClass]="{
          'btn-selected': excelSelected,
        }"
            (click)="chooseFileType('excel')"
            >
            <img src="./../assets/icons/excel-icon.png" class="icon" />
          </button>
        }
        @if (showDataTypeDropdown) {
          <div class="col-md-7 m-auto">
            <p class="card-text">{{ app.text.import.selectType }}</p>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <label
                  class="input-group-text no-border card-text ps-0 col-md-1"
                  for="inputGroupSelect"
                  >{{ app.text.import.options }}</label
                  >
                </div>
                <select
                  class="custom-select select-input col-md-10"
                  id="inputGroupSelect"
                  [(ngModel)]="app.import.type"
                  onchange="this.dataset.chosen = this.value"
                  >
                  <option value="null">{{ app.text.import.choose }}</option>
                  @for (type of types; track type) {
                    <option
                      [value]="type"
                      class="select-text"
                      >
                      {{ getLabel(type) }}
                    </option>
                  }
                </select>
              </div>
              @if (app.import.type !== 'assembly' && app.import.type !== null) {
                <button
                  class="btn btn-sm pull-left btn-delete"
                  (click)="delete.open(); deletingType = app.import.type"
                  [title]="app.text.import.next"
                  >
                  {{ app.text.import.deleteAllDocsType }}&nbsp;&nbsp;
                  <i class="fad fa-trash"></i>
                </button>
              }
            </div>
          }
        </div>
        <div class="col-6 d-flex justify-content-center align-items-center">
          <button
            class="btn d-flex justify-content-center align-items-center type-btn"
        [ngClass]="{
          'btn-selected': jsonSelected,
        }"
            (click)="chooseFileType('json')"
            >
            <img src="./../assets/icons/json-icon.png" class="icon" />
          </button>
        </div>
      </div>
    }
    @if (app.import.step === 'second') {
      <div class="row">
        <div class="col-8 m-auto">
          <div class="drag-drop-files-container">
            <app-drag-drop-files
              [acceptedExtensions]="fileExtension"
            ></app-drag-drop-files>
          </div>
        </div>
        <div class="col-8 sample m-auto">
          @if (app.language === 'en') {
            <div class="mt-1">
              @if (app.import.type === 'part') {
                <a
                  class="link"
                  href="./assets/docs/Item.xlsx"
                  target="_blank"
                  >
                  <i class="fas fa-file-word fa-lg"> </i>&nbsp;&nbsp;{{
                  app.text.import.downloadSample
                  }}
                </a>
              }
              @if (app.import.type === 'assembly') {
                <a
                  class="link"
                  href="./assets/docs/Assembly.xlsx"
                  target="_blank"
                  >
                  <i class="fas fa-file-word"> </i>&nbsp;&nbsp;{{
                  app.text.import.downloadSample
                  }}
                </a>
              }
              @if (app.import.type === 'manufacturer') {
                <a
                  class="link"
                  href="./assets/docs/Manufacturer.xlsx"
                  target="_blank"
                  >
                  <i class="fas fa-file-word"> </i>&nbsp;&nbsp;{{
                  app.text.import.downloadSample
                  }}
                </a>
              }
              @if (app.import.type === 'thread') {
                <a
                  class="link"
                  href="./assets/docs/Cases_en.xlsx"
                  target="_blank"
                  >
                  <i class="fas fa-file-word"> </i>&nbsp;&nbsp;{{
                  app.text.import.downloadSample
                  }}
                </a>
              }
              @if (app.import.type === 'warehouseGroup') {
                <a
                  class="link"
                  href="./assets/docs/Warehouse_Groups_Definition_en.xlsx"
                  target="_blank"
                  >
                  <i class="fas fa-file-word"> </i>&nbsp;&nbsp;{{
                  app.text.import.downloadSample
                  }}
                </a>
              }
              @if (app.import.type === 'manufacturerResponsibles') {
                <a
                  class="link"
                  href="./assets/docs/Manufacturer_Responsibles_en.xlsx"
                  target="_blank"
                  >
                  <i class="fas fa-file-word"> </i>&nbsp;&nbsp;{{
                  app.text.import.downloadSample
                  }}
                </a>
              }
              @if (app.import.type === 'productTypeResponsibles') {
                <a
                  class="link"
                  href="./assets/docs/Product_Type_Responsibles_en.xlsx"
                  target="_blank"
                  >
                  <i class="fas fa-file-word"> </i>&nbsp;&nbsp;{{
                  app.text.import.downloadSample
                  }}
                </a>
              }
            </div>
          }
          @if (app.language === 'de') {
            <div class="mt-1">
              @if (app.import.type === 'part') {
                <a
                  class="link"
                  href="./assets/docs/Item.xlsx"
                  target="_blank"
                  >
                  <i class="fas fa-file-word fa-lg"> </i>&nbsp;&nbsp;{{
                  app.text.import.downloadSample
                  }}
                </a>
              }
              @if (app.import.type === 'assembly') {
                <a
                  class="link"
                  href="./assets/docs/Assembly.xlsx"
                  target="_blank"
                  >
                  <i class="fas fa-file-word"> </i>&nbsp;&nbsp;{{
                  app.text.import.downloadSample
                  }}
                </a>
              }
              @if (app.import.type === 'manufacturer') {
                <a
                  class="link"
                  href="./assets/docs/Manufacturer.xlsx"
                  target="_blank"
                  >
                  <i class="fas fa-file-word"> </i>&nbsp;&nbsp;{{
                  app.text.import.doawnloadSample
                  }}
                </a>
              }
              @if (app.import.type === 'thread') {
                <a
                  class="link"
                  href="./assets/docs/Cases_de.xlsx"
                  target="_blank"
                  >
                  <i class="fas fa-file-word"> </i>&nbsp;&nbsp;{{
                  app.text.import.doawnloadSample
                  }}
                </a>
              }
              @if (app.import.type === 'warehouseGroup') {
                <a
                  class="link"
                  href="./assets/docs/Warenguppen_Definition_de.xlsx"
                  target="_blank"
                  >
                  <i class="fas fa-file-word"> </i>&nbsp;&nbsp;{{
                  app.text.import.downloadSample
                  }}
                </a>
              }
              @if (app.import.type === 'manufacturerResponsibles') {
                <a
                  class="link"
                  href="./assets/docs/Manufacturer_Responsibles_en.xlsx"
                  target="_blank"
                  >
                  <i class="fas fa-file-word"> </i>&nbsp;&nbsp;{{
                  app.text.import.downloadSample
                  }}
                </a>
              }
              @if (app.import.type === 'productTypeResponsibles') {
                <a
                  class="link"
                  href="./assets/docs/Product_Type_Responsibles_en.xlsx"
                  target="_blank"
                  >
                  <i class="fas fa-file-word"> </i>&nbsp;&nbsp;{{
                  app.text.import.downloadSample
                  }}
                </a>
              }
            </div>
          }
        </div>
        <div class="col-8 m-auto">
          <div class="col-md-12 mt-4 rules">
            <div class="rules-container">
              <div class="ribbon">{{ app.text.import.uploadRules }}</div>
              <ul class="col-md-12 py-3">
                <div class="mb-3"></div>
                <li class="ml-4">
                  {{ app.text.import.rule1 }}
                </li>
                <li class="ml-4">
                  {{ app.text.import.rule2 }}
                </li>
                <li class="ml-4">
                  {{ app.text.import.rule3 }}
                </li>
                <li class="ml-4">
                  {{ app.text.import.rule4 }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    }

    @if (app.import.step === 'error') {
      <div class="mt-5">
        <div class="col-4 m-auto card">
          <div class="card-message">
            <i class="fas fa-exclamation-triangle"></i>&nbsp;
            {{ app.text.import.errorMessage }}
            {{ app.text.import.fieldsMissing }}
            @if (app.import.invalidKeys) {
              <ul>
                @for (field of app.import.invalidKeys; track field) {
                  <li>
                    {{ app.text.import.column }}&nbsp;{{ field.columnIndex }} /
                    <span class="text-danger">
                      {{ field.fieldId | json }}
                    </span>
                  </li>
                }
              </ul>
            }
            {{ app.text.import.tryAgain }}
          </div>
        </div>
      </div>
    }

    @if (app.import.step === 'third') {
      <div class="col-12 mt-5">
        <button
          class="btn btn-save pull-right py-2 mx-2"
      (click)="
        app.import.saveAllDocsBasedOnType(app.state.importBuffer.docs.data)
      "
          [title]="app.text.import.next"
          [disabled]="app.import.hasInvalidValues"
          >
          {{ app.text.import.save }}
        </button>
        <button class="btn btn-clear pull-right" (click)="onClear()">
          <i class="fas fa-redo"></i>&nbsp; {{ app.text.import.clear }}
        </button>
        @if (fileType === 'json' && app.import.file.size > 0) {
          <div
            class="col-4 m-auto card"
            >
            <div class="card-message">
              {{ app.text.import.filesReady }}
            </div>
            @if (app.import.hasInvalidValues) {
              <pre class="format">
                <div>
                  <b>{{ app.text.part.invalidPartNumbers }}</b>
                  <div class="lh-1 scroll">
                    @for (invalidValue of app.import.invalidValues; track invalidValue) {
                      <div>
                        {{ invalidValue }}
                      </div>
                    }
                  </div>
                </div>
              </pre>
            }
            @if (app.import.step !== 'third') {
              <button
                class="btn pull-right"
                (click)="app.import.saveAllDocsBasedOnType()"
                [title]="app.text.import.next"
                >
                {{ app.text.import.next }}&nbsp;
                <i class="far fa-arrow-right"></i>
              </button>
            }
          </div>
        }
        @if (fileType === 'excel') {
          <div class="pt-5 mb-5 mx-2">
            @if (app.import.duplicatedItems.length > 0) {
              <div class="row">
                <div class="col-md-12 mb-1">
                  <dl class="row alert alert-danger pb-1 m-1">
                    <dt class="col-sm-1 p-1">
                      <i class="fas fa-times-hexagon"></i>
                    </dt>
                    <dd class="col-sm-11 error-content">
                      <p class="m-0 p-0 error-message-wrong">
                        {{ app.text.app.wentWrong }}
                      </p>
                      <p class="m-0 p-0 error-info">
                        {{ app.text.part.removedBom }}
                        @for (i of app.import.duplicatedItems; track i) {
                          <span>
                            &nbsp;&nbsp;{{ i }}&nbsp;&nbsp;
                          </span>
                        }
                      </p>
                    </dd>
                  </dl>
                </div>
              </div>
            }
            <div class="tableFixHead">
              <table class="table spacing-table table-striped">
                <thead>
                  @if (app.import.type) {
                    <tr>
                      <th class="table-cell">Select</th>
                      @for (id of app.import.importedKeys; track id) {
                        <th class="table-cell">
                          {{ getFieldLabel(app.import.type, id) }}
                        </th>
                      }
                    </tr>
                  }
                </thead>
                <tbody>
                  @for (doc of app.import.docs; track doc) {
                    <tr>
                      <td
                        [ngClass]="{ invalidValue: doc.invalidValue }"
                        class="table-cell"
                        >
                        @if (app.import.checkIfSelected(doc)) {
                          <button
                            class="btn"
                            [ngbTooltip]="app.text.import.removeItem"
                            (click)="app.import.toggleDoc(doc, 'remove')"
                            >
                            <i class="far fa-check-square"></i>
                          </button>
                        }
                        @if (!app.import.checkIfSelected(doc)) {
                          <button
                            class="btn"
                            [ngbTooltip]="app.text.import.addItem"
                            (click)="app.import.toggleDoc(doc, 'add')"
                            >
                            <i class="far fa-square"></i>
                          </button>
                        }
                      </td>
                      @for (id of app.import.importedKeys; track id) {
                        <td
                          [ngClass]="{ invalidValue: doc.invalidValue }"
                          class="table-cell"
                          >
                          <div>
                            @if (
                              app.import.type === 'manufacturer' &&
                              id !== 'parts' &&
                              id !== 'nameRaw' &&
                              id !== 'manufacturerPartNumberRaw' &&
                              id !== 'vehicleName' &&
                              id !== 'partNumber' &&
                              id !== 'lastOrderDate'
                              ) {
                              <span
                                >{{ doc[id] }}</span
                                >
                              }
                              @if (
                                app.import.type !== 'manufacturer' &&
                                id !== 'parts' &&
                                !isAssemblyBomColumn(id)
                                ) {
                                <span
                                  >{{ doc[id] }}</span
                                  >
                                }
                              </div>
                              @if (id === 'parts') {
                                <div>
                                  @for (partNumber of doc.bom; track partNumber) {
                                    <span
                                      >{{ partNumber }}&nbsp;&nbsp;</span
                                      >
                                    }
                                  </div>
                                }
                                @if (isAssemblyBomColumn(id)) {
                                  <div>
                                    @for (partNumber of doc.bom; track partNumber) {
                                      <div>
                                        @if (id === 'designator') {
                                          <app-limit
                                            [textInput]="getAssemblyBomValue(doc, partNumber, id)"
                                            limit="20"
                                          ></app-limit>
                                        } @else {
                                          {{ getAssemblyBomValue(doc, partNumber, id) }}
                                        }
                                      </div>
                                    }
                                  </div>
                                }
                                @if (id === 'nameRaw') {
                                  <div
                                    [ngbTooltip]="app.text.import.docExists"
                                    >
                                    <span [ngClass]="{ redLine: app.import.markAsExisting(doc) }">
                                      {{ doc[id] }}
                                    </span>
                                  </div>
                                }
                                @if (
                                  id === 'manufacturerPartNumberRaw' ||
                                  id === 'vehicleName' ||
                                  (id === 'partNumber' && app.import.type === 'manufacturer')
                                  ) {
                                  <div
                                    [ngbTooltip]="app.text.import.docExists"
                                    >
                                    <span [ngClass]="{ redLine: app.import.markAsExisting(doc) }">
                                      {{ doc[id] }}
                                    </span>
                                  </div>
                                }
                                @if (id === 'lastOrderDate' && doc[id] > 0) {
                                  <span>
                                    {{ doc[id] | date : "yyyy-MM-dd" : "UTC" }}
                                  </span>
                                }
                              </td>
                            }
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              }
            </div>
          }
        </div>
